import { action } from '@ember/object';
import { type Registry as Services, service } from '@ember/service';
import Component from '@glimmer/component';
import { cached } from '@glimmer/tracking';
import { PrismSelectInput } from '@mylighthouse/prism-ember';
import type { MealTypeValues } from 'lumen/utils/constants/general-constants';
import {
  MEALTYPE_ICONS,
  MEALTYPE_TRANSLATION_KEYS,
  RATE_INSIGHT_FILTER_TYPE_MEALTYPE,
} from 'lumen/utils/constants/general-constants';
import type { SelectInputOptionWithId } from 'lumen/utils/constants/pi-constant-values';

interface GeneralSelectionsMealPlanSignature {
  Args: {
    allMealPlans: MealTypeValues[];
    onChange: (option: MealTypeValues) => void;
    selectedMealPlan: MealTypeValues;
  };
}

export default class GeneralSelectionsMealPlan extends Component<GeneralSelectionsMealPlanSignature> {
  @service declare intl: Services['intl'];

  // Preserve reference for isEqual check in PowerSelect code
  @cached
  // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
  get mealPlanOptions() {
    return this.args.allMealPlans.map((mealPlan) => ({
      id: mealPlan,
      label: this.intl.t(MEALTYPE_TRANSLATION_KEYS[mealPlan]),
      icon: MEALTYPE_ICONS[mealPlan],
      type: RATE_INSIGHT_FILTER_TYPE_MEALTYPE,
    }));
  }

  // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
  get selectedMealPlan() {
    return this.mealPlanOptions.find(
      (mealPlan) => mealPlan.id === this.args.selectedMealPlan,
    );
  }

  @action onChange(option: SelectInputOptionWithId<MealTypeValues>): void {
    this.args.onChange(option.id);
  }

  <template>
    <PrismSelectInput
      @onChange={{this.onChange}}
      @options={{this.mealPlanOptions}}
      @value={{this.selectedMealPlan}}
    />
  </template>
}
